import React from 'react';

// Simple className utility function
const cn = (...classes) => {
  return classes.filter(Boolean).join(' ');
};

// Button variant styles
const buttonVariants = {
  // Base styles
  base: "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  
  // Variants
  default: "bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500",
  destructive: "bg-red-600 text-white hover:bg-red-700 focus:ring-red-500",
  outline: "border border-gray-300 bg-transparent hover:bg-gray-50 text-gray-700 focus:ring-gray-500",
  secondary: "bg-gray-100 text-gray-900 hover:bg-gray-200 focus:ring-gray-500",
  ghost: "bg-transparent hover:bg-gray-100 text-gray-700 focus:ring-gray-500",
  link: "text-blue-600 underline-offset-4 hover:underline bg-transparent focus:ring-blue-500",
  
  // WanderVibe specific variants
  hero: "bg-red-400 text-white hover:bg-red-500 shadow-lg transform hover:scale-105 transition-all duration-200 focus:ring-red-500",
  heroOutline: "border-2 border-teal-600 text-teal-600 bg-transparent hover:bg-teal-600 hover:text-white transform hover:scale-105 transition-all duration-200 focus:ring-teal-500",
  accent: "bg-purple-400 text-white hover:bg-purple-500 transform hover:scale-105 transition-all duration-200 focus:ring-purple-500",
  cta: "bg-teal-600 text-white hover:bg-teal-700 shadow-lg text-base font-semibold transform hover:scale-105 transition-all duration-200 focus:ring-teal-500",
};

// Size styles
const sizeVariants = {
  default: "h-10 px-4 py-2",
  sm: "h-9 px-3 text-sm",
  lg: "h-11 px-8 text-base",
  xl: "h-14 px-10 text-lg rounded-lg",
  icon: "h-10 w-10",
  touch: "h-12 px-6 py-3", // Mobile-friendly touch target
};

const Button = React.forwardRef(({ 
  className = '', 
  variant = 'default', 
  size = 'default', 
  children, 
  ...props 
}, ref) => {
  const baseClasses = buttonVariants.base;
  const variantClasses = buttonVariants[variant] || buttonVariants.default;
  const sizeClasses = sizeVariants[size] || sizeVariants.default;
  
  return (
    <button
      className={cn(baseClasses, variantClasses, sizeClasses, className)}
      ref={ref}
      {...props}
    >
      {children}
    </button>
  );
});

Button.displayName = "Button";

export { Button };